import React, { Component } from "react";
import { connect } from "react-redux";
import { logout } from "../../../actions/user";
import Logo from "../logo/logo";
import { Form } from "semantic-ui-react";
import { TextInput } from "../inputs/inputs";
import { AddIcon, MoreIcon } from "../icons/icons";
import { TertiaryButton, TertiaryLinkButton } from "../../ui/button/button";
import FlyoutContainer from "../../ui/flyout/flyoutContainer";
import { List, ListItemButton } from "../../ui/list/list";
import styles from "./header.css";

class Header extends Component {
	constructor() {
		super();

		this.state = {
			searchValue: ""
		};

		this.onSubmit = this.onSubmit.bind(this);
	}

	onSubmit = e => {
		const { searchValue } = this.state;
		const spaceRegex = new RegExp(" ", "g");
		const hashRegex = new RegExp("#", "g");
		const searchCleaned = searchValue
			.replace(spaceRegex, "+")
			.replace(hashRegex, "%23");

		if (!searchValue) {
			this.props.history.push(`/`);
		} else {
			this.props.history.push(`/search?q=${searchCleaned}`);
		}
	};

	onChange = e => {
		this.setState({
			[e.target.name]: e.target.value
		});
	};

	logout = () => this.props.logout();

	componentDidMount = () => {
		this.setState({
			searchValue: this.props.searchQuery
		});
	};

	render() {
		return (
			<div>
				<header className={styles.header}>
					<Logo />
					<Form onSubmit={this.onSubmit} className={styles.search}>
						<TextInput
							type="text"
							name="searchValue"
							value={this.state.searchValue || ""}
							placeholder="Search"
							onChange={this.onChange}
						/>
					</Form>

					<TertiaryLinkButton href="/bookmark/create" className={styles.button}>
						<AddIcon />
					</TertiaryLinkButton>

					<FlyoutContainer>
						<TertiaryButton className={styles.button}>
							<MoreIcon />
						</TertiaryButton>
						<List>
							<ListItemButton onClick={this.logout}>Logout</ListItemButton>
						</List>
					</FlyoutContainer>
				</header>
				<div className={styles.headerSpacer} />
			</div>
		);
	}
}

export default connect(
	null,
	{ logout }
)(Header);



// WEBPACK FOOTER //
// ./src/components/ui/header/header.js